import axios from 'axios';

export const getPartnerPrograms = async (query: string = '') => {
    return await axios.get(process.env.REACT_APP_API_URL + 'partner-programs/' + query);
};
